import React, {FC, useEffect, useState} from "react";
import {ScrollView, StyleSheet, Text, View} from "react-native";
import {AppTheme, useTheme} from "../../theme/colors";
import UmoLogoBW from "../../Icons/umo-logo-bw";
import {Storage, Store} from "../../utils/Storage";
import PageContainer from "../../components/PageContainer";
import {Button, Gap} from "../../components";
import {ButtonType} from "../../theme";
import {useAppContext} from "../../contexts/AppContext";
import {CircumstancesType} from "../../constants";

interface SharePreviewProps {
    onPressClose: () => void;
}

const SharePreview: FC<SharePreviewProps> = ({onPressClose}) => {
    const theme = useTheme();
    const sharePreviewStyles = getSharePreviewStyles(theme);
    const {mode} = useAppContext();
    const [store, setStore] = useState<Partial<Store> | null>(null);

    const loadStore = async () => {
        const storeData = await Storage.getStorage();
        setStore(storeData);
    };

    useEffect(() => {
        loadStore();
    }, []);

    const renderProfileFormFields = () => (
      <>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>First Name</Text>
              <Text style={sharePreviewStyles.blockText}>{store?.given_name}</Text>
          </View>

          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Last Name</Text>
              <Text style={sharePreviewStyles.blockText}>{store?.family_name}</Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Email</Text>
              <Text style={sharePreviewStyles.blockText}>{store?.email}</Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Date of Birth</Text>
              <Text style={sharePreviewStyles.blockText}>{store?.profile_dob}</Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Gender</Text>
              <Text style={sharePreviewStyles.blockText}>{store?.gender}</Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>University</Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_university}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Course</Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_course}
              </Text>
          </View>



          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>GP Surgery & number</Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_gp_details}
              </Text>
          </View>

          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Trusted Contact Name & Number
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_contacts}
              </Text>
          </View>

          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Supporting Services
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_support_services}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Supporting friends and family
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.profile_support_network}
              </Text>
          </View>

          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Who supports me at University
              </Text>
              <Text style={sharePreviewStyles.blockText}>{store?.profile_work}</Text>
          </View>

          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Mental health and neurodiveristy triggers{" "}
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_triggers}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Areas of my life impacting wellbeing
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_impact}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  What Would I Like My Support Network To Do When They Notice Signs Of
                  Worsen Health{" "}
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_network}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  Positives Aspects of Life / Things I’m good at{" "}
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_aspects}
              </Text>
          </View>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>Support Strategies </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_strategies}
              </Text>
          </View>

      </>
    );
    const renderWellBiengFormFields = () => (
      <>
          <View style={sharePreviewStyles.block}>
              <Text style={sharePreviewStyles.blockLabel}>
                  {" "}
                  Signs My Mental Health Is Getting Worse
              </Text>
              <Text style={sharePreviewStyles.blockText}>
                  {store?.passport_signs}
              </Text>
          </View>


          {mode.includes(CircumstancesType.MENTAL_HEALTH) && (
            <>
                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Current Mental Health Issues
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.mh_issues_current}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Past Mental Health Issues
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.mh_issues_past}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Mental Health Challenges
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.mh_challenges}
                    </Text>
                </View>
            </>
          )}
          {mode.includes(CircumstancesType.NEURODIVERSITY) && (
            <>
                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        What is your Neurodiversity
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.neuro_details?.join(",")}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Is your Neurodiversity diagnosed, undiagnosed or on a referral
                        pathway
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.neuro_diagnosed}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Neurodiversity Challenges{" "}
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.neuro_challenges}
                    </Text>
                </View>
            </>
          )}
          {mode.includes(CircumstancesType.WELLBEING) && (
            <>
                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Current Wellbeing Issues (e.g. Bereavement, Relationship
                        breakdown, Financial Stress, Workload stress…)
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.wb_current}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Past Wellbeing Issues (e.g. Bereavement, Relationship breakdown,
                        Financial Stress, Workload stress…){" "}
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>{store?.wb_past}</Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Wellbeing Challenges ( e.g. attendance, communication,
                        withdrawing, connecting with others, accessing support,
                        homesickness, productivity…){" "}
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.wb_challenges}
                    </Text>
                </View>
            </>
          )}
          {mode.includes(CircumstancesType.DISABILITY) && (
            <>
                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        What is your disability{" "}
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.disabilty_details}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Difficulties due to disability{" "}
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.disabilty_difficulties}
                    </Text>
                </View>

                <View style={sharePreviewStyles.block}>
                    <Text style={sharePreviewStyles.blockLabel}>
                        Disability-related Challenges
                    </Text>
                    <Text style={sharePreviewStyles.blockText}>
                        {store?.disabilty_challenges}
                    </Text>
                </View>
            </>
          )}
      </>
    );

    return (
      <PageContainer loading={!store}>
          <ScrollView contentContainerStyle={sharePreviewStyles.viewContainer}>
              <View style={sharePreviewStyles.headerView}>
                  <UmoLogoBW width={200} height={58}/>
                  <Button
                    title="Close"
                    variant={ButtonType.secondary}
                    onPress={onPressClose}
                  />
              </View>

              {renderProfileFormFields()}
              <Gap gap={50}/>
              {renderWellBiengFormFields()}
          </ScrollView>
      </PageContainer>
    );
};

export default SharePreview;

const getSharePreviewStyles = (theme: AppTheme) => {
    return StyleSheet.create({
        viewContainer: {
            backgroundColor: theme.BACKGROUND,
            paddingVertical: 30,
            paddingHorizontal: 15,
        },
        headerView: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
        },

        block: {
            marginBottom: 30,
            gap: 5,
        },
        blockLabel: {
            fontSize: 14,
            fontWeight: "600",
            color: theme.TEXT,
        },
        blockText: {
            fontSize: 14,
            fontWeight: "300",
            color: theme.TEXT,
        },
    });
};
